const links = {
  "links.CLI_repository": "https://cli.ibexa.cloud/",
  "links.blackfire.connect": "https://blackfire.io/session/connect/ibexa",
  "links.documentation.CLI":
    "https://doc.ibexa.co/en/latest/ibexa_cloud/install_on_ibexa_cloud/",
  "links.documentation.download_code":
    "https://doc.ibexa.co/en/latest/ibexa_cloud/install_on_ibexa_cloud/",
  "links.documentation.wizard":
    "https://doc.ibexa.co/en/latest/ibexa_cloud/ibexa_cloud/"
};

export default links;
